import { useParams } from 'react-router-dom';

import { AppUpdateArticlePage } from '~/components/pages/AppUpdateArticlePage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppUpdateArticleRoute: React.FC = () => {
  const { appId, articleId } = useParams();
  const navigate = useNavigate();

  if (!appId || !articleId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId} noAppPreviewOverlap>
      <AppUpdateArticlePage appId={appId} articleId={articleId} />
    </DashboardTemplate>
  );
};
